import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { ajaxActions } from 'common/ajax/store.js';
import Alert from 'common/alert/Alert.js';
import AccountDetails from './AccountDetails';
import Address from './Address';
import ContactDetails from './ContactDetails';

const styles = (theme) => ({
  root: {},
});

class Profile extends React.Component {
  closeAlert = () => {
    this.props.resetAjaxStatus();
  };

  render() {
    const { classes, localisation, profileDetails, ajax } = this.props;
    const { showSuccessAlert } = ajax;
    return (
      <div>
        <Grid container className={classes.root} spacing={3}>
          <Grid item xs={12}>
            <Alert
              variant={'success'}
              visible={showSuccessAlert}
              message={'Your changes have been saved successfully'}
              onClose={this.closeAlert}
            />
          </Grid>

          <Grid item md={4} xs={12}>
            <Grid container direction="column" spacing={3}>
              <Grid item>
                <AccountDetails
                  profileDetails={profileDetails}
                  localisation={localisation}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={4} xs={12}>
            <ContactDetails
              profileDetails={profileDetails}
              localisation={localisation}
            />
          </Grid>

          <Grid item md={4} xs={12}>
            <Grid item>
              <Address
                profileDetails={profileDetails}
                localisation={localisation}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

Profile.propTypes = {
  classes: PropTypes.object.isRequired,
  localisation: PropTypes.object,
};

const mapStateToProps = (state) => ({
  ajax: state.ajax,
});

const mapDispatchToProps = (dispatch) => {
  return {
    resetAjaxStatus: () => {
      dispatch(ajaxActions.resetAjaxStatus());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Profile));
